<button mat-icon-button [matMenuTriggerFor]="userMenu">
  <mat-icon>person</mat-icon>
</button>
<mat-menu #userMenu>
  <div mat-menu-item disabled>{{(authService.currentUser | async)?.email}}</div>
  @if (allowImpersonation) {
  <button mat-menu-item (click)="switchUser()">Switch User</button>
  }
  <button mat-menu-item (click)="logout()">Logout</button>
</mat-menu>
